import { TorusGeometry, SphereGeometry, OctahedronGeometry, MeshNormalMaterial, MeshPhongMaterial, Color } from 'three';
import OrbitField from './OrbitField.js';

let genHex = size => [...Array(size)].map(() => Math.floor(Math.random() * 16).toString(16)).join('');

/**
 * The outer shape field - donuts, spheres and diamonds orbiting the scene at a
 * distance, well outside the central cluster.
 *
 * These are far enough away that the detail of the central cluster's geometry
 * would be wasted, so they use much coarser tessellation: a 70-donut ring at
 * the cluster's 20x45 segments would cost 126k triangles on its own, where
 * 8x16 costs 18k and looks the same at this distance.
 */
export default class OuterShapes {
    constructor(params) {
        const repulsion = params.repulsion.outer;
        const shared = {
            minRadius: 48,
            maxRadius: 82,
            minScale: 1.5,
            maxScale: 4,
            speed: 0.04
        };

        this.donuts = new OrbitField(
            new TorusGeometry(0.3, 0.2, 8, 16),
            new MeshNormalMaterial({ wireframe: true }),
            params.outerDonutsAmount,
            shared,
            repulsion
        );

        this.spheres = new OrbitField(
            new SphereGeometry(0.2, 12, 8),
            new MeshNormalMaterial(),
            params.outerSpheresAmount,
            shared,
            repulsion
        );

        this.diamonds = new OrbitField(
            new OctahedronGeometry(0.2),
            new MeshPhongMaterial(),
            params.outerDiamondsAmount,
            shared,
            repulsion
        );

        const color = new Color();
        for (let i = 0; i < params.outerDiamondsAmount; i++) {
            this.diamonds.mesh.setColorAt(i, color.set("#" + genHex(6)));
        }
        this.diamonds.mesh.instanceColor.needsUpdate = true;

        this.fields = [this.donuts, this.spheres, this.diamonds];
    }

    setVisible(visible) {
        this.fields.forEach(field => { field.mesh.visible = visible; });
    }

    update(delta) {
        this.fields.forEach(field => field.update(delta));
    }
}
